module.exports = __webpack_public_path__ + "static/media/eurosender.52c32aec.jpg";